exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header.bg-dark[data-v-15e4a794]{background-color:#f6f7f7!important;color:#000!important;padding:5px 10px}.card-body[data-v-15e4a794]{min-height:150px}@media screen and (max-width:768px){.card[data-v-15e4a794]{margin-left:5px!important;width:185px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15e4a794","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/displayers/display-date.vue
// module id = 1699
// module chunks = 0